import {User, type UserData} from "@/types/users/user";

export class SalePersonPurchaser {
    public id: number | null;
    public code: string;
    public name: string;
    public tms_road_name: string;
    public job_title: string;
    public commission: number | null;
    public phone_no: string;
    public email: string;
    public blocked: boolean;
    public privacy_blocked: number | null;
    public user: User | null;

    constructor(data: SalePersonPurchaserData | void) {
        if (data === undefined) {
            this.id = null;
            this.code = "";
            this.name = "";
            this.tms_road_name = "";
            this.job_title = "";
            this.commission = null;
            this.phone_no = "";
            this.email = "";
            this.blocked = false;
            this.privacy_blocked = null;
            this.user = null;

        } else {
            this.id = data.id;
            this.code = data.code;
            this.name = data.name;
            this.tms_road_name = data.tms_road_name;
            this.job_title = data.job_title;
            this.commission = data.commission;
            this.phone_no = data.phone_no;
            this.email = data.email;
            this.blocked = data.blocked;
            this.privacy_blocked = data.privacy_blocked;
            if (data.user !== undefined && data.user !== null) {
                this.user = new User(data.user);
            } else {
                this.user = null;
            }
        }
    }
}

export type SalePersonPurchaserData = {
    id: number | null;
    code: string;
    name: string;
    tms_road_name: string;
    job_title: string;
    commission: number | null;
    phone_no: string;
    email: string;
    blocked: boolean;
    privacy_blocked: number | null;
    user: UserData | null | undefined;
}